<template>
  <div>
    <vxe-grid
      ref="table"
      border
      resizable
      auto-resize
      highlight-hover-row
      size="small"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="300"
      :checkbox-config="{ highlight: true }"
      :edit-config="{ enabled: true, trigger: 'click', mode: 'row' }"
      :edit-rules="editRules"
    >
      <template v-slot:top>
        <slot name="header"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableColumns: tableColumns(),
      editRules: {
        vehicleModel: [
          {
            required: true,
            message: '请选择车型',
          },
          {
            validator: ({ $table, row, cellValue }) => {
              if (!cellValue) {
                return new Error('请选择车型')
              }

              const { tableData: data } = $table.getTableData()
              const { _XID: rowId } = row
              const _data = data.filter((item) => item._XID !== rowId)
              const vehicleModels = _data.map((item) => item.vehicleModel)
              if (vehicleModels.includes(cellValue)) {
                return new Error('车型重复，请检查')
              }
            },
          },
        ],
        qty: [
          {
            required: true,
            message: '请输入数量',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error('数量不能为0')
              }
              if (cellValue < 1) {
                return new Error('数量不能小于1')
              }
            },
          },
        ],
      },
    }
  },
  methods: {
    validate() {
      return this.$refs.table
        .fullValidate()
        .then(() => true)
        .catch(() => false)
    },
    getTableData() {
      const data = this.$refs.table.getTableData()
      return data.tableData
    },
    getCheckboxRecords() {
      return this.$refs.table.getCheckboxRecords()
    },
    async addRow() {
      const $table = this.$refs.table
      const { row: newRow } = await $table.insertAt({ qty: 1 }, -1)
      await $table.setActiveCell(newRow, 'vehicleModel')
    },
    del(row) {
      this.$refs.table.remove(row)
    },
    removeCheckboxRow() {
      const data = this.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message.warning('请选择车型信息')
        return
      }
      this.del(data)
    },
  },
}
</script>
